export default "__VITE_ASSET__CFqcq2l2__"